<template>
  <!-- <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <i class="fab fa-twitter"></i>
          </div>
          <p class="category">Folowers</p>
          <h3 class="title">
            +245
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Just Updated
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <p class="category">Website Visits</p>
          <h3 class="title">
            75.521
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>local_offer</md-icon>
            Tracked from Google Analytics
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>store</md-icon>
          </div>
          <p class="category">Revenue</p>
          <h3 class="title">
            $ 34.245
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>date_range</md-icon>
            Last 24 Hours
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="warning">
        <template slot="header">
          <div class="card-icon">
            <md-icon>weekend</md-icon>
          </div>
          <p class="category">Bookings</p>
          <h3 class="title">
            184
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon class="text-danger">warning</md-icon>
            <a href="#pablo">Get More Space...</a>
          </div>
        </template>
      </stats-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="fakturMonthlyChart.data"
        :chart-options="fakturMonthlyChart.options"
        :chart-responsive-options="fakturMonthlyChart.responsiveOptions"
        chart-type="Bar"
        chart-inside-header
        background-color="rose"
      >
        <md-icon slot="fixed-button">build</md-icon>
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Website Views</h4>
          <p class="category">
            Last Campaign Performance
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated 10 days ago
          </div>
        </template>
      </chart-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="dailySalesChart.data"
        :chart-options="dailySalesChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="green"
      >
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Daily Sales</h4>
          <p class="category">
            <span class="text-success"
              ><i class="fas fa-long-arrow-alt-up"></i>
              55%
            </span>
            increase in today sales.
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated 4 minutes ago
          </div>
        </template>
      </chart-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="dataCompletedTasksChart.data"
        :chart-options="dataCompletedTasksChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="blue"
      >
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Completed Tasks</h4>
          <p class="category">
            Last Campaign Performance
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            campaign sent 26 minutes ago
          </div>
        </template>
      </chart-card>
    </div>

    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-warning">
          <div class="card-text">
            <h4 class="title">Employees Stats</h4>
            <p class="category">
              New employees on 15th September, 2016
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table v-model="users" table-header-color="orange">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Id">{{ item.id }}</md-table-cell>
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Salary">{{ item.salary }}</md-table-cell>
              <md-table-cell md-label="Country">{{ item.country }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <nav-tabs-card>
        <template slot="content">
          <span class="md-nav-tabs-title">Tasks</span>
          <md-tabs md-sync-route class="md-rose" md-alignment="left">
            <md-tab id="tab-home" md-label="Bugs" md-icon="bug_report">
              <md-table v-model="firstTabs" @md-selected="onSelect">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    md-selectable="multiple"
                    md-auto-select
                >
                  <md-table-cell>{{ item.tab }}</md-table-cell>
                  <md-table-cell>
                    <md-button class="md-just-icon md-simple md-primary">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="top">Edit</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-simple md-danger">
                      <md-icon>close</md-icon>
                      <md-tooltip md-direction="top">Close</md-tooltip>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

            <md-tab id="tab-pages" md-label="Website" md-icon="code">
              <md-table v-model="secondTabs" @md-selected="onSelect">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    md-selectable="multiple"
                    md-auto-select
                >
                  <md-table-cell>{{ item.tab }}</md-table-cell>
                  <md-table-cell>
                    <md-button class="md-just-icon md-simple md-primary">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="top">Edit</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-simple md-danger">
                      <md-icon>close</md-icon>
                      <md-tooltip md-direction="top">Close</md-tooltip>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

            <md-tab id="tab-posts" md-label="Server" md-icon="cloud">
              <md-table v-model="thirdTabs" @md-selected="onSelect">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    md-selectable="multiple"
                    md-auto-select
                >
                  <md-table-cell>{{ item.tab }}</md-table-cell>
                  <md-table-cell>
                    <md-button class="md-just-icon md-simple md-primary">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="top">Edit</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-simple md-danger">
                      <md-icon>close</md-icon>
                      <md-tooltip md-direction="top">Close</md-tooltip>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-tab>

          </md-tabs>
        </template>
      </nav-tabs-card>
    </div>

  </div> -->
  <div class="md-layout">
    <!-- <div class="md-layout-item" style="margin-bottom:100px">
    <dashboard-main></dashboard-main>
    </div> -->
    <div v-if="fakturNotaJasaChart.data.labels.length != 0 && fakturNotaJasaChart.data.series.length != 0" 
    class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
      <chart-card
        :chart-data="fakturNotaJasaChart.data"
        :chart-options="fakturNotaJasaChart.options"
        :chart-responsive-options="fakturNotaJasaChart.responsiveOptions"
        chart-type="Line"
        chart-inside-header
        background-color="rose"
      >
        <md-icon slot="fixed-button">build</md-icon>
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Faktur Nota Jasa</h4>
          <p class="category">
            Total Pendapatan dari Nota Jasa
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            <!-- updated 10 days ago -->
          </div>
        </template>
      </chart-card>
    </div>

    <div v-if="fakturNotaPartChart.data.labels.length != 0 && fakturNotaPartChart.data.series.length != 0" 
    class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
      <chart-card
        :chart-data="fakturNotaPartChart.data"
        :chart-options="fakturNotaPartChart.options"
        :chart-responsive-options="fakturNotaPartChart.responsiveOptions"
        chart-type="Line"
        chart-inside-header
        background-color="rose"
      >
        <md-icon slot="fixed-button">build</md-icon>
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>
        <md-button class="md-simple md-just-icon" slot="second-button">
          <md-icon>edit</md-icon>
          <md-tooltip md-direction="bottom">Change Date</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Faktur Nota Part</h4>
          <p class="category">
            Total Pendapatan dari Nota Part
          </p>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            <!-- updated {{10 days ago}} -->
          </div>
        </template>
      </chart-card>
    </div>

    <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-warning">
          <div class="card-text">
            <h4 class="title">Procurement Order</h4>
            <p class="category">
              Not approved yet and not payment yet
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table :value="procure" class="paginated-table table-striped table-hover" table-header-color="orange">

            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="pagination.perPage" name="pages" @md-selected="onPerPage">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <md-field >
                
              </md-field>
            </md-table-toolbar>
            
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Procurement Orde No.">{{ item.procurement_order_no }}</md-table-cell>
              <md-table-cell md-label="Status"> 
                <p v-if="item.procurement_order_status == 0">Created</p>
                <p v-if="item.procurement_order_status == 1">Accepted</p>
                <p v-if="item.procurement_order_status == 2">Completed</p></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between" >
          
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
             @input="onPagination"
          />
        </md-card-actions>
      </md-card>
    </div> -->

    <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-warning">
          <div class="card-text">
            <h4 class="title">Status Repair Vehicle</h4>
            <p class="category">
              PKB data with status "in-progress"
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table :value="repair" table-header-color="orange">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Procurement Orde No.">{{ item.pkb_no }}</md-table-cell>
              <md-table-cell md-label="Status"> 
                <p v-if="item.procurement_order_status == 0">Created</p>
                <p v-if="item.procurement_order_status == 1">Accepted</p>
                <p v-if="item.pkb_status == 3">Service in-progress</p></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div> -->

    <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-warning">
          <div class="card-text">
            <h4 class="title">Spare Part Trace Hold</h4>
            <p class="category">
              Stock under Trace Hold
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table :value="tablePartThresholder" table-header-color="orange">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Procurement Orde No.">{{ item.spare_part_master_name }}</md-table-cell>
              <md-table-cell md-label="Stock">{{ item.spare_part_master_stock }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div> -->

    <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
       <md-card>
        <!-- <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Procurement Order</h4>
          
        </md-card-header> -->
        <md-card-header class="md-card-header-text md-card-header-warning">
          <div class="card-text">
            <h4 class="title">Procurement Order</h4>
            <p class="category">
              PO with payment not done yet.
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          
          <md-table
            :value="tablePageProcurementOrder"
            :md-sort.sync="sortationProcurementOrder.field"
            :md-sort-order.sync="sortationProcurementOrder.order"
           
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="paginationProcurementOrder.perPage" name="pages" @md-selected="onPerPage('ProcurementOrder')">
                  <md-option
                    v-for="item in paginationProcurementOrder.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <md-field >
                <md-input placeholder="Search..." v-model="searchProcurementOrder" @input="searchOnTable('ProcurementOrder')" ref="searchRef" />
              </md-field>
            </md-table-toolbar>

 

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ID" md-sort-by="id">{{
                item.id
              }}</md-table-cell>
              <md-table-cell md-label="Detail" >
                <router-link :to="{name: 'Detail Procurement Order', params: { id: item.id }}" class="btn btn-primary">{{item.procurement_order_no}}
                </router-link>
              </md-table-cell>
              <md-table-cell md-label="Status" md-sort-by="spare_part_master_name">
                <p v-if="item.procurement_order_status == 0">Registered</p>
                <p v-if="item.procurement_order_status == 1">Waiting Manager Approval</p>
                <p v-if="item.procurement_order_status == 2">Rejected</p>
                <p v-if="item.procurement_order_status == 3">Waiting Price Check</p>
                <p v-if="item.procurement_order_status == 4">Waiting CEO Approval</p>
                <p v-if="item.procurement_order_status == 5">Waiting Payment</p>
              </md-table-cell>
              <!-- <md-table-cell md-label="Actions">
                <md-menu md-direction="bottom-start">
                  <md-button class="md-icon-button md-raised md-info" md-menu-trigger><md-icon>menu</md-icon></md-button>
                    <md-menu-content>
                      
                      <md-menu-item @click="editSparePartMaster(item.id)" >Edit</md-menu-item>
                      <md-menu-item @click="deleteConfirmation(item.id)">Delete</md-menu-item>
                    </md-menu-content>
                </md-menu> -->
                <!-- <md-button
                  class="md-icon-button md-raised md-round md-info"
                  @click="editSparePartMaster(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                  class="md-icon-button md-raised md-round md-danger"
                  @click="deleteConfirmation(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button> -->
              <!-- </md-table-cell> -->
            </md-table-row>
          </md-table>

          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTableProcurementOrder"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between" >
          <div class="">
            <p v-if="totalProcurementOrder!=0" class="card-category">
              Showing {{ fromProcurementOrder + 1 }} to {{ toProcurementOrder }} of {{ totalProcurementOrder }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="paginationProcurementOrder.currentPage"
            :per-page="paginationProcurementOrder.perPage"
            :total="totalProcurementOrder"
             @input="onPagination('ProcurementOrder')"
          />
        </md-card-actions>
      </md-card>
    </div>

    <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-50 md-small-size-100">
       <md-card>
        <!-- <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Status Repair Vehicle</h4>
          
        </md-card-header> -->
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Status Repair Vehicle</h4>
            <p class="category">
              vehicle that is in the process of being serviced.
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          
          <md-table
            :value="tablePageRepairStatus"
            :md-sort.sync="sortationRepairStatus.field"
            :md-sort-order.sync="sortationRepairStatus.order"
           
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="paginationRepairStatus.perPage" name="pages" @md-selected="onPerPage('RepairStatus')">
                  <md-option
                    v-for="item in paginationRepairStatus.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <md-field >
                <md-input placeholder="Search..." v-model="searchRepairStatus" @input="searchOnTable('RepairStatus')" ref="searchRef" />
              </md-field>
            </md-table-toolbar>

 

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ID" md-sort-by="id">{{
                item.id
              }}</md-table-cell>
              <md-table-cell md-label="Detail" >
                <router-link :to="{name: 'Detail PKB', params: { id: item.id }}" class="btn btn-primary">{{item.pkb_no}}
                </router-link>
              </md-table-cell>
              <md-table-cell md-label="Status" md-sort-by="pkb_status">
                <p v-if="item.pkb_status == 0">Created</p>
                <p v-if="item.pkb_status == 1">Accepted</p>
                <p v-if="item.pkb_status == 2">Service-In Progress</p>
                <p v-if="item.pkb_status == 3">Waiting Part</p>
              </md-table-cell>
              <!-- <md-table-cell md-label="Actions">
                <md-menu md-direction="bottom-start">
                  <md-button class="md-icon-button md-raised md-info" md-menu-trigger><md-icon>menu</md-icon></md-button>
                    <md-menu-content>
                      
                      <md-menu-item @click="editSparePartMaster(item.id)" >Edit</md-menu-item>
                      <md-menu-item @click="deleteConfirmation(item.id)">Delete</md-menu-item>
                    </md-menu-content>
                </md-menu> -->
                <!-- <md-button
                  class="md-icon-button md-raised md-round md-info"
                  @click="editSparePartMaster(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                  class="md-icon-button md-raised md-round md-danger"
                  @click="deleteConfirmation(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button> -->
              <!-- </md-table-cell> -->
            </md-table-row>
          </md-table>

          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTableRepairStatus"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between" >
          <div class="">
            <p v-if="totalRepairStatus!=0" class="card-category">
              Showing {{ fromRepairStatus + 1 }} to {{ toRepairStatus }} of {{ totalRepairStatus }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="paginationRepairStatus.currentPage"
            :per-page="paginationRepairStatus.perPage"
            :total="totalRepairStatus"
             @input="onPagination('RepairStatus')"
          />
        </md-card-actions>
      </md-card>
    </div>


    <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100 md-small-size-100">
       <md-card>
        <!-- <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Spare Part Tracehold</h4>
          
        </md-card-header> -->
        <md-card-header class="md-card-header-text md-card-header-danger">
          <div class="card-text">
            <h4 class="title">Spare Part Tracehold</h4>
            <p class="category">
              almost out of stock
            </p>
          </div>
        </md-card-header>
        <md-card-content>
          
          <md-table
            :value="tablePagePartThresholder"
            :md-sort.sync="sortationPartThresholder.field"
            :md-sort-order.sync="sortationPartThresholder.order"
           
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="paginationPartThresholder.perPage" name="pages" @md-selected="onPerPage('PartThresholder')">
                  <md-option
                    v-for="item in paginationPartThresholder.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <md-field >
                <md-input placeholder="Search..." v-model="searchPartThresholder" @input="searchOnTable('PartThresholder')" ref="searchRef" />
              </md-field>
            </md-table-toolbar>

 

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="ID" md-sort-by="id">{{
                item.id
              }}</md-table-cell>
              <md-table-cell md-label="Spare Part Name" md-sort-by="spare_part_master_name">{{
                item.spare_part_master_name
              }}</md-table-cell>
              <md-table-cell md-label="Stock" md-sort-by="spare_part_master_stock">{{
                item.spare_part_master_stock
              }}</md-table-cell>
              <md-table-cell md-label="Spare Part Trace Hold" md-sort-by="spare_part_master_threshold">{{
                item.spare_part_master_threshold
              }}</md-table-cell>
              <!-- <md-table-cell md-label="Actions">
                <md-menu md-direction="bottom-start">
                  <md-button class="md-icon-button md-raised md-info" md-menu-trigger><md-icon>menu</md-icon></md-button>
                    <md-menu-content>
                      
                      <md-menu-item @click="editSparePartMaster(item.id)" >Edit</md-menu-item>
                      <md-menu-item @click="deleteConfirmation(item.id)">Delete</md-menu-item>
                    </md-menu-content>
                </md-menu> -->
                <!-- <md-button
                  class="md-icon-button md-raised md-round md-info"
                  @click="editSparePartMaster(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                  class="md-icon-button md-raised md-round md-danger"
                  @click="deleteConfirmation(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button> -->
              <!-- </md-table-cell> -->
            </md-table-row>
          </md-table>

          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTablePartThresholder"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between" >
          <div class="">
            <p v-if="totalPartThresholder!=0" class="card-category">
              Showing {{ fromPartThresholder + 1 }} to {{ toPartThresholder }} of {{ totalPartThresholder }} entries
            </p>
          </div>
          <pagination 
            class="pagination-no-border pagination-success"
            v-model="paginationPartThresholder.currentPage"
            :per-page="paginationPartThresholder.perPage"
            :total="totalPartThresholder"
             @input="onPagination('PartThresholder')"
          />
        </md-card-actions>
      </md-card>
    </div>

   

  </div>

  
</template>

<script>
import Dashboard from "@/pages/Dashboard/Dashboard.vue"
import Pagination from "@/components/Pagination";

import {
  StatsCard,
  ChartCard,
  NavTabsCard
} from "@/components";

const toLower = text => {
  var rt = ""
    if(text){
       rt = text.toString().toLowerCase()
    }
    return rt
  }
export default {
  components: {
    //  "dashboard-main" : Dashboard,
     pagination: Pagination,
    // StatsCard,
    ChartCard,
    // NavTabsCard
  },

  data() {
    return {
      procure: [],
      tableProcurementOrder: [],
      tablePartThresholder: [],
      tableRepairStatus: [],
    
      tablePagefilterPartThresholder: [],
      tablePagePartThresholder: [],
      footerTablePartThresholder: [],
      searchPartThresholder: null,

      tablePagefilterServiceReminder: [],
      tablePageServiceReminder: [],
      footerTableServiceReminder: [],
      searchServiceReminder: null,

      tablePagefilterProcurementOrder: [],
      tablePageProcurementOrder: [],
      footerTableProcurementOrder: [],
      searchProcurementOrder: null,

      tablePagefilterRepairStatus: [],
      tablePageRepairStatus: [],
      footerTableRepairStatus: [],
      searchRepairStatus: null,
    
      queryProcurementOrder: null,
      queryPartThresholder: null,
      queryRepairStatus: null,

      sortationPartThresholder: {
        field: "spare_part_master_name",
        order: "desc",
      },

      sortationServiceReminder: {
        field: "id",
        order: "desc",
      },
      sortationProcurementOrder: {
        field: "procurement_order_no",
        order: "desc",
      },
      sortationRepairStatus: {
        field: "pkb_no",
        order: "desc",
      },

      paginationPartThresholder: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },

      paginationServiceReminder: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },
      paginationProcurementOrder: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },
      paginationRepairStatus: {
        perPage: 3,
        currentPage: 1,
        perPageOptions: [1,3, 5, 10, 25, 50],
      },


      totalProcurementOrder: 0,
      totalPartThresholder: 0,
      totalRepairStatus: 0,
      totalServiceReminder: 0,

      // product1: process.env.VUE_APP_BASE_URL + "/img/card-2.jpg",
      // product2: process.env.VUE_APP_BASE_URL + "/img/card-3.jpg",
      // product3: process.env.VUE_APP_BASE_URL + "/img/card-1.jpg",
      // seq2: 0,

      // selected: [],
      // firstTabs: [
      //   { tab: "Sign contract for \"What are conference organizers afraid of?\""},
      //   { tab: "Lines From Great Russian Literature? Or E-mails From My Boss?" },
      //   { tab: "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit" },
      //   { tab: "Create 4 Invisible User Experiences you Never Knew About" }
      // ],
      // secondTabs: [
      //   {
      //     tab:
      //       "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
      //   },
      //   {
      //     tab:
      //       "Sign contract for \"What are conference organizers afraid of?\""
      //   }
      // ],
      // thirdTabs: [
      //   {
      //     tab:
      //       "Lines From Great Russian Literature? Or E-mails From My Boss?"
      //   },
      //   {
      //     tab:
      //       "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
      //   },
      //   {
      //     tab:
      //       "Sign contract for \"What are conference organizers afraid of?\""
      //   }
      // ],

      // users: [
      //   {
      //     id: 1,
      //     name: "Noelia O'Kon",
      //     salary: "13098.00",
      //     country: "Niger"
      //   },
      //   {
      //     id: 2,
      //     name: "Mr. Enid Von PhD",
      //     salary: "35978.00",
      //     country: "Curaçao"
      //   },
      //   {
      //     id: 3,
      //     name: "Colton Koch",
      //     salary: "26278.00",
      //     country: "Netherlands"
      //   },
      //   {
      //     id: 4,
      //     name: "Gregory Vandervort",
      //     salary: "25537.00",
      //     country: "South Korea"
      //   },
      // ],
      // dailySalesChart: {
      //   data: {
      //     labels: ["M", "T", "W", "T", "F", "S", "S"],
      //     series: [[12, 17, 7, 17, 23, 18, 38]]
      //   },
      //   options: {
      //     lineSmooth: this.$Chartist.Interpolation.cardinal({
      //       tension: 0
      //     }),
      //     low: 0,
      //     high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      //     chartPadding: {
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       left: 0
      //     }
      //   }
      // },
      // dataCompletedTasksChart: {
      //   data: {
      //     labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
      //     series: [[230, 750, 450, 300, 280, 240, 200, 190]]
      //   },

      //   options: {
      //     lineSmooth: this.$Chartist.Interpolation.cardinal({
      //       tension: 0
      //     }),
      //     low: 0,
      //     high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      //     chartPadding: {
      //       top: 0,
      //       right: 0,
      //       bottom: 0,
      //       left: 0
      //     }
      //   }
      // },
      // emailsSubscriptionChart: {
      //   data: {
      //     labels: [
      //       "Ja",
      //       "Fe",
      //       "Ma",
      //       "Ap",
      //       "Mai",
      //       "Ju",
      //       "Jul",
      //       "Au",
      //       "Se",
      //       "Oc",
      //       "No",
      //       "De"
      //     ],
      //     series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
      //   },
      //   options: {
      //     axisX: {
      //       showGrid: false
      //     },
      //     low: 0,
      //     high: 1000,
      //     chartPadding: {
      //       top: 0,
      //       right: 5,
      //       bottom: 0,
      //       left: 0
      //     }
      //   },
      //   responsiveOptions: [
      //     [
      //       "screen and (max-width: 640px)",
      //       {
      //         seriesBarDistance: 5,
      //         axisX: {
      //           labelInterpolationFnc: function(value) {
      //             return value[0];
      //           }
      //         }
      //       }
      //     ]
      //   ]
      // }

      fakturNotaJasaChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          chartPadding: {
            top: 40,
            right: 5,
            bottom: 0,
            left: 30
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },

      fakturNotaPartChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          chartPadding: {
            top: 40,
            right: 5,
            bottom: 0,
            left: 30
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      }


    };
  },

  computed:{
    fromPartThresholder() {
      
      return this.paginationPartThresholder.perPage * (this.paginationPartThresholder.currentPage - 1);
    },

    toPartThresholder() {
      
      let highBound = this.fromPartThresholder + this.paginationPartThresholder.perPage;
      if (this.totalPartThresholder < highBound) {
        highBound = this.totalPartThresholder;
      }
      return highBound;
    },

    fromServiceReminder() {
      
      return this.paginationServiceReminder.perPage * (this.paginationServiceReminder.currentPage - 1);
    },

    toServiceReminder() {
      
      let highBound = this.fromServiceReminder + this.paginationServiceReminder.perPage;
      if (this.totalServiceReminder < highBound) {
        highBound = this.totalServiceReminder;
      }
      return highBound;
    },

    fromProcurementOrder() {
      
      return this.paginationProcurementOrder.perPage * (this.paginationProcurementOrder.currentPage - 1);
    },

    toProcurementOrder() {
      
      let highBound = this.fromProcurementOrder + this.paginationProcurementOrder.perPage;
      if (this.totalProcurementOrder < highBound) {
        highBound = this.totalProcurementOrder;
      }
      return highBound;
    },

    fromRepairStatus() {
      
      return this.paginationRepairStatus.perPage * (this.paginationRepairStatus.currentPage - 1);
    },

    toRepairStatus() {
      
      let highBound = this.fromRepairStatus + this.paginationRepairStatus.perPage;
      if (this.totalRepairStatus < highBound) {
        highBound = this.totalRepairStatus;
      }
      return highBound;
    },

  },

  created() {
      this.getData();
    },
  methods: {
    // ambil data yang dibutuhkan
    async getData(){
      await this.$store.dispatch("workshop_dashboard/fakturNotaJasa")
      //this.nota_part = await this.$store.getters["workshop_nota_part/nota_part"]
      let labelsNotaJasa=[]
      let nilaiNotaJasa=[] 

      // check data dashboard null atau tidak
      if(await this.$store.getters["workshop_dashboard/dashboard"] && await this.$store.getters["workshop_dashboard/dashboard"].length!=0){
        await this.$store.getters["workshop_dashboard/dashboard"].map(function(value, key) {
        labelsNotaJasa.push(value.monthNotaJasa);
        nilaiNotaJasa.push(value.totalNotaJasa); 
        });
        this.fakturNotaJasaChart.data.labels = labelsNotaJasa
        this.fakturNotaJasaChart.data.series = [nilaiNotaJasa]

        console.log(this.fakturNotaJasaChart.data.labels)
      }
      

      await this.$store.dispatch("workshop_dashboard/fakturNotaPart")
      //this.nota_part = await this.$store.getters["workshop_nota_part/nota_part"]
      let labelsNotaPart=[]
      let nilaiNotaPart=[] 

     if(await this.$store.getters["workshop_dashboard/dashboard"] && await this.$store.getters["workshop_dashboard/dashboard"].length!=0){
          await this.$store.getters["workshop_dashboard/dashboard"].map(function(value, key) {
            labelsNotaPart.push(value.monthNotaPart);
            nilaiNotaPart.push(value.totalNotaPart);
          });
          this.fakturNotaPartChart.data.labels = labelsNotaPart
          this.fakturNotaPartChart.data.series = [nilaiNotaPart]
      }

      

      // await this.$store.dispatch("procurementOrder/dashboard")
      // await this.$store.getters["workshop_dashboard/dashboard"]

      await this.$store.dispatch("workshop_dashboard/procurementOrder")

      if(await this.$store.getters["workshop_dashboard/dashboard"] && await Object.keys(this.$store.getters["workshop_dashboard/dashboard"]).length!=0){
          this.tableProcurementOrder = await this.$store.getters["workshop_dashboard/dashboard"]
          this.tablePagefilterProcurementOrder = this.paginate(this.tableProcurementOrder, this.paginationProcurementOrder.perPage)
          this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
          this.totalProcurementOrder =  this.tableProcurementOrder.length
      
      }
      
      await this.$store.dispatch("workshop_dashboard/repairStatus")
       if(await this.$store.getters["workshop_dashboard/dashboard"] && await Object.keys(this.$store.getters["workshop_dashboard/dashboard"]).length!=0){
          this.tableRepairStatus = await this.$store.getters["workshop_dashboard/dashboard"]
          this.tablePagefilterRepairStatus = this.paginate(this.tableRepairStatus, this.paginationRepairStatus.perPage)
          this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
          this.totalRepairStatus =  this.tableRepairStatus.length
      
      }
      
        
      await this.$store.dispatch("workshop_dashboard/traceHold")
      console.log('weweew')
       if(await this.$store.getters["workshop_dashboard/dashboard"] && await Object.keys(this.$store.getters["workshop_dashboard/dashboard"]).length!=0){
         
         this.tablePartThresholder = await this.$store.getters["workshop_dashboard/dashboard"]
          this.tablePagefilterPartThresholder = this.paginate(this.tablePartThresholder, this.paginationPartThresholder.perPage)
          this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
          this.totalPartThresholder =  this.tablePartThresholder.length
          
          console.log(await this.$store.getters["workshop_dashboard/dashboard"])  
      }

    
      
    },
    onSelect: function(items) {
      this.selected = items;
    },

    onPagination (jenis) {
       //console.log(this.pagination.currentPage)
       if(jenis == "PartThresholder"){
         this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
       }

       if(jenis == "ServiceReminder"){
         this.tablePageServiceReminder = this.tablePagefilterServiceReminder[this.paginationServiceReminder.currentPage-1]
       }

       if(jenis == "ProcurementOrder"){
         this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
       }

       if(jenis == "RepairStatus"){
         this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
       }
    },

    onPerPage(jenis){
      if(jenis == "PartThresholder"){
        this.tablePagefilterPartThresholder = this.paginate(this.tablePartThresholder, this.paginationPartThresholder.perPage)
        this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
      }

      if(jenis == "PartThresholder"){
        this.tablePagefilterServiceReminder = this.paginate(this.tableServiceReminder, this.paginationServiceReminder.perPage)
        this.tablePageServiceReminder = this.tablePagefilterServiceReminder[this.paginationServiceReminder.currentPage-1]
      }

      if(jenis == "ProcurementOrder"){
        this.tablePagefilterProcurementOrder = this.paginate(this.tableProcurementOrder, this.paginationProcurementOrder.perPage)
        this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
      }

      if(jenis == "RepairStatus"){
        this.tablePagefilterRepairStatus = this.paginate(this.tableRepairStatus, this.paginationRepairStatus.perPage)
        this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
      }
    },
    paginate (arr, size) {
      return arr.reduce((acc, val, i) => {
        let idx = Math.floor(i / size)
        let page = acc[idx] || (acc[idx] = [])
        page.push(val)

        return acc
      }, [])
    },
    searchOnTable (jenis) {
      if(jenis == "PartThresholder"){
          var resultFilter = []
          resultFilter = this.tablePartThresholder.filter(item => toLower(item.spare_part_master_code).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_name).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_unit).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_unit_price).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_type).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_category).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.spare_part_master_alert_price).includes(toLower(this.searchPartThresholder)) ||
                                                  toLower(item.created_at).includes(toLower(this.searchPartThresholder))
                                          )
                                
          if(resultFilter.length != 0){
            this.totalPartThresholder = resultFilter.length
            this.tablePagefilterPartThresholder = this.paginate(resultFilter, this.paginationPartThresholder.perPage)
            this.tablePagePartThresholder = this.tablePagefilterPartThresholder[this.paginationPartThresholder.currentPage-1]
            
          }
          else{
            this.tablePagePartThresholder = [] 
          }
      }


      if(jenis == "ProcurementOrder"){
          var resultFilter = []
          resultFilter = this.tableProcurementOrder.filter(item => toLower(item.procurement_order_no).includes(toLower(this.searchProcurementOrder)) ||
                                                  toLower(item.procurement_order_status).includes(toLower(this.searchProcurementOrder)) ||
                                                  toLower(item.created_at).includes(toLower(this.searchProcurementOrder))
                                          )
                                
          if(resultFilter.length != 0){
            this.totalProcurementOrder = resultFilter.length
            this.tablePagefilterProcurementOrder = this.paginate(resultFilter, this.paginationProcurementOrder.perPage)
            this.tablePageProcurementOrder = this.tablePagefilterProcurementOrder[this.paginationProcurementOrder.currentPage-1]
            
          }
          else{
            this.tablePageProcurementOrder = [] 
          }
      }

      if(jenis == "RepairStatus"){
          var resultFilter = []
          resultFilter = this.tableRepairStatus.filter(item => toLower(item.pkb_no).includes(toLower(this.searchRepairStatus)) ||
                                                  toLower(item.procurement_order_status).includes(toLower(this.searchRepairStatus)) ||
                                                  toLower(item.created_at).includes(toLower(this.searchRepairStatus))
                                          )
                                
          if(resultFilter.length != 0){
            this.totalRepairStatus = resultFilter.length
            this.tablePagefilterRepairStatus = this.paginate(resultFilter, this.paginationRepairStatus.perPage)
            this.tablePageRepairStatus = this.tablePagefilterRepairStatus[this.paginationRepairStatus.currentPage-1]
            
          }
          else{
            this.tablePageRepairStatus = [] 
          }
      }
      
      
       
      },
      
  }
};
</script>
<style scoped>
/* .md-layout{
  background-color: white;
} */

</style>
